<template>
  <div>
    <div v-for="(item,index) in simple" :key="index" style="margin-bottom: 0.2rem">
    <md-field>
        <md-skeleton avatar title :loading="loading" :row="10" class="skeleton-item">
        <md-cell-item :title="item.transCode" :brief="'預計時效：'+item.fastestDay+'~'+item.latestDay+'天(工作日)'">
          <p slot="children" style="color: #e51c23;font-size: 0.16em">
            {{item.priceText}}
          </p>
        </md-cell-item>
        <md-cell-item title="線路須知" :brief="item.notice"/>
        </md-skeleton>
    </md-field>
    </div>
      <md-field>
        <p style="font-size: 0.4rem;text-align: left;margin: 0.1rem 0;font-weight: 500">基本服務</p>
        <md-skeleton avatar title :loading="loading" :row="10" class="skeleton-item">
          <md-cell-item title="秤重拍照" brief="入庫的每個包裹秤重時都會拍照，打消您的顧慮" style="margin-top: 0.2rem">
            <img src="@/assets/image/zhaopianpaizhao.png" alt="" slot="left" style="width: 1rem">
          </md-cell-item>
          <md-cell-item title="倉儲服務" brief="包裹入庫後在規定時間內享受免費倉儲期，您可以悠閒地選購" style="margin-top: 0.2rem">
            <img src="@/assets/image/cangchu.png" alt="" slot="left" style="width: 1rem">
          </md-cell-item>
          <md-cell-item title="合包發貨" brief="將您的多個包裹合併成一個發貨，節約您的運費" style="margin-top: 0.2rem">
          <img src="@/assets/image/jiagubao.png" alt="" slot="left" style="width: 1rem">
        </md-cell-item>
        </md-skeleton>
      </md-field>
    <md-field style="margin: 0.2rem 0" >
      <p style="font-size: 0.4rem;text-align: left;margin: 0.1rem 0;font-weight: 500">增值服務</p>
      <md-skeleton avatar title :loading="loading" :row="10" class="skeleton-item">
        <md-cell-item title="特殊加固" brief="對於貴重物品，您可以選擇特殊加固，長途運輸更安全" style="margin-top: 0.2rem">
          <img src="@/assets/image/gaojijiagu.png" alt="" slot="left" style="width: 1rem">
        </md-cell-item>
        <md-cell-item title="倉庫退件" brief="未合包前，如您的東西不想要了可選擇退件服務" style="margin-top: 0.2rem">
          <img src="@/assets/image/tui.png" alt="" slot="left" style="width: 1rem">
        </md-cell-item>
<!--        <md-cell-item title="包裹保价" brief="如怕丟件或破損，你可選擇保價服務，丟件壞件可賠付" style="margin-top: 0.2rem">-->
<!--          <img src="@/assets/image/icon_index_baojia.png" alt="" slot="left" style="width: 1rem">-->
<!--        </md-cell-item>-->
      </md-skeleton>
    </md-field>
  </div>
</template>

<script>
import { Field, CellItem, Skeleton } from 'mand-mobile'

export default {
  name: 'server',
  components: {
    [Skeleton.name]: Skeleton,
    [Field.name]: Field,
    [CellItem.name]: CellItem
  },
  data () {
    return {
      loading: true,
      simple: []
    }
  },
  activated () {
    this.servicePrice()
  },
  methods: {
    servicePrice () {
      const par = {
        countryId: this.$route.query.id
      }
      this.http.APIASK(this.ports.servicePrice, 'get', par).then(res => {
        this.simple = res
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less">
  .md-cell-item-content{
    text-align: left;
  }
  .md-cell-item-body.multilines{
    padding: 0;
  }
  .md-cell-item-body:before{
    border-bottom-color: #ffffff;
  }
  fieldset{
    padding: 0.1rem !important;
    padding-left: 0.3rem !important;
  }
  .md-cell-item-brief{
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .skeleton-item {
    text-align: left;
  }
</style>
